export default __webpack_public_path__ + "static/media/SWT0250.34I-20292_-14773_0.d7eb18aa.jpg";